export const GET_FLOAT_DATA = "GET_FLOAT_DATA";
export const GET_FLOAT_DATA_SUCCESS = "GET_FLOAT_DATA_SUCCESS";
export const GET_FLOAT_DATA_FAILED = "GET_FLOAT_DATA_FAILED";
export const GET_FLOAT_DATA_BY_ID = "GET_FLOAT_DATA_BY_ID";
export const GET_FLOAT_DATA_BY_ID_SUCCESS = "GET_FLOAT_DATA_BY_ID_SUCCESS";
export const GET_FLOAT_DATA_BY_ID_FAILED = "GET_FLOAT_DATA_BY_ID_FAILED";
export const GET_FLOAT_DATA_BY_TRANSACTION_ID = "GET_FLOAT_DATA_BY_TRANSACTION_ID";
export const GET_FLOAT_DATA_BY_TRANSACTION_ID_SUCCESS = "GET_FLOAT_DATA_BY_TRANSACTION_ID_SUCCESS";
export const GET_FLOAT_DATA_BY_TRANSACTION_ID_FAILED = "GET_FLOAT_DATA_BY_TRANSACTION_ID_FAILED";
export const ADD_UPDATE_BALANCE = "ADD_UPDATE_BALANCE";
export const ADD_UPDATE_BALANCE_SUCCESS = "ADD_UPDATE_BALANCE_SUCCESS";
export const ADD_UPDATE_BALANCE_FAILED = "ADD_UPDATE_BALANCE_FAILED";
export const GET_CURRENT_BALANCE = "GET_CURRENT_BALANCE";
export const GET_CURRENT_BALANCE_SUCCESS = "GET_CURRENT_BALANCE_SUCCESS";
export const GET_CURRENT_BALANCE_FAILED = "GET_CURRENT_BALANCE_FAILED";
